<template>
  <div class="sidebar" :class="menuActive ? 'active' : ''">
    <div class="sidebar__logo">
      <img class="large" src="/logo.png" alt="Logo Weeare" />
      <img class="small" src="/logo-small.png" alt="Logo Weeare" />
    </div>
    <nav
      class="sidebar__menu"
      @mouseover="menuHover ? (menuActive = true) : ''"
      @mouseleave="menuHover ? (menuActive = false) : ''"
    >
      <div class="">
        <b-select
          v-model="subRole"
          expanded
          size="is-small"
          class="mb-4 mr-5"
          @input="changeSubRole"
        >
          <option
            v-if="roles.includes(ROLES.COMPANY_POINT)"
            :value="ROLES.COMPANY_POINT"
          >
            Puntos
          </option>
          <option
            v-if="roles.includes(ROLES.RECOMPENSA)"
            :value="ROLES.RECOMPENSA"
          >
            Recompensa
          </option>
          <option
            v-if="roles.includes(ROLES.CLIENT_CODE)"
            :value="ROLES.CLIENT_CODE"
          >
            Regalos
          </option>
          <option
            v-if="roles.includes(ROLES.SERVICE_USER)"
            :value="ROLES.SERVICE_USER"
          >
            Validador
          </option>
        </b-select>
      </div>
      <div>
        <!-- Vistas del codigo -->
        <div v-if="currentRole === ROLES.COMPANY_GROUP">
          <template v-if="currentSubRole === ROLES.CLIENT_CODE">
            <router-link
              v-for="r in routesCodigo"
              :key="r.name"
              :to="{ name: r.name }"
            >
              <div class="sidebar__menu__item">
                <div class="sidebar__menu__content">
                  <font-awesome-icon
                    :icon="['fas', r.icon]"
                    class="sidebar__menu__item__icon"
                  />
                  <div class="sidebar__menu__item__name">
                    {{ r.title }}
                  </div>
                </div>
              </div>
            </router-link>
            <div class="mb-5" />
          </template>
          <template v-if="currentSubRole === ROLES.COMPANY_POINT">
            <component
              v-for="r in routesPuntos"
              :is="r.children ? 'div' : 'router-link'"
              :key="r.name"
              :to="{ name: r.name }"
            >
              <div class="sidebar__menu__item">
                <div class="sidebar__menu__content">
                  <font-awesome-icon
                    :icon="['fas', r.icon]"
                    class="sidebar__menu__item__icon"
                  />
                  <div class="sidebar__menu__item__name">
                    {{ r.title }}
                  </div>
                </div>
                <div v-if="r.children" class="sidebar__sub__menu__item">
                  <div
                    v-for="c in r.children"
                    :key="c.name"
                    class="sidebar__children"
                  >
                    <router-link :to="{ name: c.name }">
                      {{ c.title }}
                    </router-link>
                  </div>
                </div>
              </div>
            </component>
            <div class="mb-5" />
          </template>
        </div>
        <template v-if="currentSubRole === ROLES.RECOMPENSA">
          <component
            v-for="r in routesRecompensa"
            :is="r.children ? 'div' : 'router-link'"
            :key="r.name"
            :to="{ name: r.name }"
          >
            <div class="sidebar__menu__item">
              <div class="sidebar__menu__content">
                <font-awesome-icon
                  :icon="['fas', r.icon]"
                  class="sidebar__menu__item__icon"
                />
                <div class="sidebar__menu__item__name">
                  {{ r.title }}
                </div>
              </div>
              <div v-if="r.children" class="sidebar__sub__menu__item">
                <div
                  v-for="c in r.children"
                  :key="c.name"
                  class="sidebar__children"
                >
                  <router-link :to="{ name: c.name }">
                    {{ c.title }}
                  </router-link>
                </div>
              </div>
            </div>
          </component>
          <div class="mb-5" />
        </template>
        <template v-if="currentSubRole === ROLES.SERVICE_USER">
          <component
            v-for="r in routesValidador"
            :is="r.children ? 'div' : 'router-link'"
            :key="r.name"
            :to="{ name: r.name }"
          >
            <div class="sidebar__menu__item">
              <div class="sidebar__menu__content">
                <font-awesome-icon
                  :icon="['fas', r.icon]"
                  class="sidebar__menu__item__icon"
                />
                <div class="sidebar__menu__item__name">
                  {{ r.title }}
                </div>
              </div>
              <div v-if="r.children" class="sidebar__sub__menu__item">
                <div
                  v-for="c in r.children"
                  :key="c.name"
                  class="sidebar__children"
                >
                  <router-link :to="{ name: c.name }">
                    {{ c.title }}
                  </router-link>
                </div>
              </div>
            </div>
          </component>
          <div class="mb-5" />
        </template>
      </div>
    </nav>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { ROLES } from "@/utils/constants/";
import { sidebarRoutesValidador as routesValidador } from "@/router/validador.router";
import routesCodigo from "@/router/codigo.router";
import routesPuntos from "@/router/puntos.router";
import routesRecompensa from "@/router/recompensa.router";
import routesAdmin from "@/router/admin.router";
export default {
  name: "SidebarMenu",
  data() {
    return {
      routesAdmin: [],
      routesCodigo: [],
      routesPuntos: [],
      routesRecompensa: [],
      routesValidador: [],
      ROLES: ROLES
    };
  },
  mounted() {
    if (localStorage.getItem("menu") === "true") {
      this.SET_MENU_ACTIVE(true);
    }

    routesValidador.forEach(({ name, meta, separate, isTitle }) => {
      if (!meta || !meta.sidebar) return;
      if (separate) {
        this.routesValidador.push({ separate: true });
      } else if (isTitle) {
        this.routesValidador.push({
          isTitle: true,
          title: meta.title,
          icon: meta.icon
        });
      } else {
        this.routesValidador.push({
          name,
          icon: meta.icon,
          title: meta.title,
          separate: false,
          isTitle: false
        });
      }
    });

    routesCodigo.forEach(({ name, meta }) => {
      if (meta.sidebar) {
        this.routesCodigo.push({
          name,
          icon: meta.icon,
          title: meta.title
        });
      }
    });

    routesPuntos.forEach(({ name, meta, children }) => {
      if (meta.sidebar) {
        const newRoute = {
          name,
          icon: meta.icon,
          title: meta.title
        };
        if (meta.hasChildren) {
          newRoute.children = [];
          children.forEach(({ name, meta }) => {
            if (meta.sidebar) {
              newRoute.children.push({
                name,
                icon: meta.icon,
                title: meta.title
              });
            }
          });
        }
        this.routesPuntos.push(newRoute);
      }
    });

    routesRecompensa.forEach(({ name, meta }) => {
      if (meta.sidebar) {
        this.routesRecompensa.push({
          name,
          icon: meta.icon,
          title: meta.title
        });
      }
    });

    routesAdmin.forEach(({ name, meta }) => {
      if (meta.sidebar) {
        this.routesAdmin.push({
          name,
          icon: meta.icon,
          title: meta.title
        });
      }
    });
  },
  computed: {
    ...mapState("settings", [
      "roles",
      "currentRole",
      "currentSubRole",
      "menuActive",
      "menuHover"
    ]),
    subRole: {
      get() {
        return this.currentSubRole;
      },
      set(value) {
        this.SET_CURRENT_SUB_ROLE(value);
      }
    },
    menuActive: {
      get() {
        return this.$store.state.settings.menuActive;
      },
      set(value) {
        this.SET_MENU_ACTIVE(value);
      }
    }
  },
  methods: {
    ...mapMutations("settings", ["SET_CURRENT_SUB_ROLE", "SET_MENU_ACTIVE"]),
    changeSubRole(value) {
      if (value === ROLES.CLIENT_CODE || value === ROLES.COMPANY_POINT) {
        this.$router.push({ name: "home" });
      } else if (value === ROLES.RECOMPENSA) {
        this.$router.push({ name: "home-recompensa-validate" });
      } else if (value === ROLES.SERVICE_USER) {
        this.$router.push({ name: "home-validador" });
      }
    }
  }
};
</script>

<style lang="scss">
.sidebar {
  padding-top: 30px;
  position: relative;
  width: 60px;
  transition: width linear 0.1s;
  .burger {
    position: absolute;
    right: -1.4rem;
    font-size: 20px;
    cursor: pointer;
    top: 1.85rem;
    z-index: 2;
  }
  &__logo {
    overflow: hidden;
    height: 20px;
    .large {
      display: none;
      min-width: 141px;
    }
    .small {
      display: block;
      height: 20px;
    }
  }
  &__children {
    margin-left: 38px;
    font-size: 16px;
    font-family: $font-medium;
    color: $color-submenu;
    margin-bottom: 5px;
    &:last-child {
      margin-bottom: 0;
    }
    &:hover {
      color: $color-text;
    }
  }
  &__sub__menu__item {
    opacity: 0;
  }
  &__menu {
    margin-top: 30px;
    &__content {
      display: flex;
      align-items: center;
    }
    &__item {
      display: flex;
      justify-content: center;
      flex-direction: column;
      margin-bottom: 10px;
      cursor: pointer;
      width: 200px;
      $root: &;
      &__name {
        font-family: $font-medium;
        font-size: 16px;
        color: $color-text-opacity;
        transition: 0.2s ease all;
        white-space: nowrap;
        opacity: 0;
      }
      &__icon {
        color: $color-text-opacity;
        transition: 0.2s ease all;
        padding: 7px;
        width: 34px !important;
        height: 34px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 5px;
      }
      &:hover {
        #{$root}__name {
          color: $color-text;
        }
        #{$root}__icon {
          color: $color-text;
        }
      }
      &--active {
        #{$root}__name {
          color: $color-main;
        }
        #{$root}__icon {
          color: $color-main;
          background: rgba($color-text-opacity, 0.1);
        }
        &:hover {
          #{$root}__name {
            color: $color-main;
          }
          #{$root}__icon {
            color: $color-main;
          }
        }
      }
    }
  }
  &__submenu {
    margin-left: 8px;
    margin-top: 10px;
    border-left: 1.5px solid rgba(34, 43, 59, 0.1);
    padding-left: 27px;
    &__item {
      color: $color-submenu;
      padding: 4px;
      font-size: 14px;
      font-family: $font-medium;
      &:hover {
        color: $color-text;
      }
    }
  }
  &__separator {
    border: none;
    border-top: 1.5px solid rgba(34, 43, 59, 0.1);
    margin: 8px 0;
  }
  &__section__title {
    display: flex;
    align-items: center;
    padding: 4px 0;
    .sidebar__menu__item__name {
      font-family: $font-medium;
      font-size: 13px;
      color: $color-text-opacity;
      white-space: nowrap;
      opacity: 0;
      text-transform: uppercase;
      letter-spacing: 0.05em;
    }
    .sidebar__menu__item__icon {
      color: $color-text-opacity;
      padding: 7px;
      width: 34px !important;
      height: 34px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 5px;
    }
  }
  a {
    color: $color-submenu;
    &:hover {
      color: $color-text;
    }
  }
  .router-link-exact-active div,
  .router-link-exact-active svg,
  .router-link-exact-active {
    color: $color-main;
  }
}
.active {
  width: 240px;
  .sidebar__logo {
    .large {
      display: block;
      width: 141px;
    }
    .small {
      display: none;
      height: 20px;
    }
  }
  .sidebar__menu {
    &__item {
      &__name {
        opacity: 1;
      }
    }
  }
  .sidebar__sub__menu__item {
    opacity: 1;
  }
  .sidebar__section__title {
    .sidebar__menu__item__name {
      opacity: 1;
    }
  }
}
</style>
